var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessCouponChevron(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 10.8257 11.6171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 19
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.00005 11.6171C4.83453 11.6181 4.67247 11.5697 4.53453 11.4782C4.3966 11.3867 4.28904 11.2562 4.22557 11.1033C4.1621 10.9505 4.14559 10.7822 4.17815 10.6199C4.2107 10.4576 4.29085 10.3087 4.40838 10.1921L8.82505 5.78376L4.40838 1.37543C4.27186 1.21601 4.20052 1.01095 4.20862 0.80122C4.21672 0.59149 4.30366 0.39254 4.45208 0.244128C4.60049 0.0957162 4.79944 0.00877293 5.00917 0.00067197C5.2189 -0.00742899 5.42396 0.0639094 5.58338 0.200431L10.5834 5.20043C10.7386 5.35657 10.8257 5.56778 10.8257 5.78793C10.8257 6.00809 10.7386 6.2193 10.5834 6.37543L5.58338 11.3754C5.42816 11.5294 5.21866 11.6162 5.00005 11.6171Z",
    fill: "url(#paint0_linear_0_4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.628116 9.78417C0.504078 9.78483 0.382635 9.75168 0.279271 9.68896C0.175906 9.62623 0.0953036 9.53677 0.0477386 9.43198C0.000173679 9.32718 -0.0121983 9.2118 0.0122001 9.10055C0.0365985 8.9893 0.0966618 8.88722 0.184732 8.80731L3.4945 5.78534L0.184732 2.76337C0.0671396 2.6558 0.00107663 2.50991 0.00107663 2.35778C0.00107663 2.20565 0.0671396 2.05975 0.184732 1.95218C0.302325 1.84461 0.461815 1.78418 0.628116 1.78418C0.794417 1.78418 0.953907 1.84461 1.0715 1.95218L4.81841 5.37975C4.93472 5.48678 5 5.63157 5 5.78249C5 5.93341 4.93472 6.07819 4.81841 6.18523L1.0715 9.61279C1.01366 9.66677 0.944693 9.70971 0.868583 9.73913C0.792474 9.76855 0.71074 9.78386 0.628116 9.78417Z",
    fill: "url(#paint1_linear_0_4)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 10.8257,
    y1: 5.80859,
    x2: 4.16187,
    y2: 5.80859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_4",
    x1: 5,
    y1: 5.78419,
    x2: 0,
    y2: 5.78419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#822AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessCouponChevron);
export default __webpack_public_path__ + "static/media/access-coupon-chevron.97c72647b88642c8fb827ced5f30bebf.svg";
export { ForwardRef as ReactComponent };